import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import { Text } from "../../Typography";
import RadioButton from '../RadioButton';
import styles from './RadioButtonGroup.scss';

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var _classnames;

  var children = _ref.children,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      isCompact = _ref.isCompact,
      wide = _ref.wide,
      error = _ref.error,
      className = _ref.className,
      handleProps = _objectWithoutProperties(_ref, ["children", "defaultValue", "value", "isCompact", "wide", "error", "className"]);

  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      uncontrolledValue = _React$useState2[0],
      setUncontrolledValue = _React$useState2[1];

  var isUncontrolled = typeof value === 'undefined';

  var getHandleProps = function getHandleProps(currentValue) {
    return (// TODO: Remove Link handling from RadioButtonGroup
      handleProps.getUrl ? {
        to: typeof currentValue === 'string' ? handleProps.getUrl(currentValue) : ''
      } : {
        onChange: function onChange(val) {
          if (isUncontrolled) {
            setUncontrolledValue(val);
          }

          handleProps.onChange(val);
        }
      }
    );
  };

  var childClone = React.Children.map(children, function (child) {
    var isChecked = isUncontrolled ? uncontrolledValue === child.props.value : value === child.props.value;
    var itemHandleProps = getHandleProps(child.props.value);
    return /*#__PURE__*/React.createElement(child.type, Object.assign({
      key: child.props.value
    }, child.props, {
      wide: wide,
      isChecked: isChecked
    }, itemHandleProps, {
      error: error
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.radioButtonGroup, className, (_classnames = {}, _defineProperty(_classnames, styles.isCompact, isCompact), _defineProperty(_classnames, styles.wide, wide), _classnames))
  }, childClone), typeof error === 'string' && /*#__PURE__*/React.createElement(Text, {
    color: "fail",
    size: "small"
  }, error));
};

export default RadioButtonGroup;